// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosResponse, AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap, debounceTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { searchLabsKeyword } from '../../../apis/lab';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';

const { searchLabsKeywordActions } = actionCreatorsList;

const outputActions = {
  success: searchLabsKeywordActions.success,
  failure: searchLabsKeywordActions.failure
};

type RequestActionTypes = ActionType<
  typeof searchLabsKeywordActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const searchLabsKeywordEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(searchLabsKeywordActions.request)
    ),
    debounceTime(1000),
    switchMap((action: RequestActionTypes) => {
      const { limit, name } = action.payload;

      return searchLabsKeyword(limit, name)
        .then((response: AxiosResponse<any>) => {
          const { list, count } = response.data || {};
          return searchLabsKeywordActions.success({
            list,
            count,
            name
          });
        })
        .catch((error: AxiosError) => {
          return searchLabsKeywordActions.failure({ error });
        });
    }),
  );
};
